
import React ,{ useState, useEffect } from 'react';

import LinkInformationArea from '../components/LinkInformationArea';

const Siteragist = () => {

  const [categories, setCategories] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isError, setIsError] = useState(null);

  const [resErrorName, setresErrorName] = useState();
  const [resErrorUrl, setresErrorUrl] = useState();
  const [resErrorCat, setresErrorCat] = useState();
  const [resErrorImg, setresErrorImg] = useState();
  const [resErrorDetail, setresErrorDetail] = useState();
  const [isComplate, setIsComplate] = useState(false);

  
  //これは確認用
  /*
  const testSubmmit = () => {
    setIsComplate(true);
  };
  */
  
  
  const [formState, setFormState] = useState({
    siteName: '',
    siteUrl: '',
    siteCategory: '',
    siteImg:'',
    siteDetail: '',
  });

  //テキストの入力をFormStateに入れる
  const handleInputChange = (event) => {
    const { name, value} = event.target;
    
    setFormState(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  //チェックボックスの場合の処理
  const handleCheckChange = (event) => {
    const {name, value, checked,} = event.target;
    
    setFormState(prevState => {
      // 既存の配列をコピーして、新しい配列を作成
      const newCategories = [...prevState.siteCategory];
      
      if (checked) {
        // チェックされた場合、配列に値を追加
        newCategories.push(value);
      } else {
        // チェックが外された場合、配列から値を削除
        const index = newCategories.indexOf(value);
        if (index > -1) {
          newCategories.splice(index, 1);
        }
      }      
      return {
        ...prevState,
        // name属性（siteCategory）に新しい配列を設定
        [name]: newCategories
      };
    });
  };

  //画像の場合の処理
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFormState(prevState => ({
        ...prevState,
        siteImg: file // ファイル情報をstateにセット
      }));      
    }
  };  

  // フォーム送信
  const handleSubmit = (event) => {
    event.preventDefault(); // ページのリロードを防ぐ
    setIsSubmitted(true); // 送信Flag

    //console.log('送信時のcategories:', formState.siteCategory);

    //未入力チェック項目
    if (!formState.siteName || !formState.siteUrl || formState.siteCategory.length === 0 || !formState.siteDetail){      
      setIsError(true);
      return;
    }
    
    setIsError(false);

    const formData = new FormData();    
    formData.append('siteName', formState.siteName);
    formData.append('siteUrl', formState.siteUrl);
    formData.append('siteCategory', formState.siteCategory);
    formData.append('siteImg', formState.siteImg);
    formData.append('siteDetail', formState.siteDetail);
    
    
    fetch('/req_api/regist.php', {
      method: 'POST',
      body: formData, // FormDataをそのままbodyに設定
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
    // レスポンスのオブジェクトをチェックして処理を分岐
    if (data.success === true) {
      setIsComplate(true);
    } else if (data.errors) {

      if(data.errors.siteName){
          setresErrorName(data.errors.siteName);
      }
      if(data.errors.siteUrl){
          setresErrorUrl(data.errors.siteUrl);
      }
      if(data.errors.siteCategory){
          setresErrorCat(data.errors.siteCategory);
      }
      if(data.errors.siteImg){
          setresErrorImg(data.errors.siteImg);
      }
      if(data.errors.siteDetail){
          setresErrorDetail(data.errors.siteDetail);
      }

    } else {
      // 予期しないレスポンス形式の場合
      console.error('予期しないレスポンスが返されました:', data);
      alert('予期せぬエラーが発生しました。');
    }
  })
    .catch(error => console.error('Error:', error));
    
  };


  //カテゴリ一覧取得
  useEffect(() => {
    fetch('/req_api/categories.php') 
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // 取得したJSONデータをstateにセット
        setCategories(data);
      })
      .catch(error => {
        console.error('Error fetching categories:', error);
      });
  }, []);


  return (
    <main>
      <section id="site_regist">
        <div id="regist_inner">

          {isComplate ? 
          (
            <div>
              <h2 className="m_b30">登録が完了しました。</h2>
              <p className="read">内容を確認し、問題無いと判断されたサイトのみ掲載されます。<br />掲載までしばらくお待ちください。</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
            <h2>サイト登録</h2>
            {isSubmitted && isError && <p className="regist_error">未入力の項目があります</p>}
          
              <div className="regist_area">
                <p className="txt_r"><span className="red">※</span>必須項目</p>
                <dl>
                  <dt>サイト名 <span className="red">※</span></dt>
                  <dd>
                    <input type="text" className="text" name="siteName" value={formState.siteName} onChange={handleInputChange} placeholder="例：FINAL FANTASY XIV, The Lodestone" />
                    {isSubmitted && !formState.siteName && <p className="regist_error">サイト名が未入力です。</p>}
                    {resErrorName && <p className="regist_error">{resErrorName}</p>}
                  </dd>                
                </dl>
                <dl>
                  <dt>URL <span className="red">※</span></dt>
                  <dd>
                    <input type="text" className="text" name="siteUrl" value={formState.siteUrl} onChange={handleInputChange} placeholder="例：https://jp.finalfantasyxiv.com/lodestone/" />
                    {isSubmitted && !formState.siteUrl && <p className="regist_error">URLが未入力です。</p>}
                    {resErrorUrl && <p className="regist_error">{resErrorUrl}</p>}
                  </dd>
                </dl>
                <dl>
                  <dt>カテゴリー <span className="red">※</span></dt>
                  <dd>                  
                    <ul className="cat">                 
                      {Object.keys(categories).map(key => (
                        <li key={key}>
                          <label><input type="checkbox" name="siteCategory" onChange={handleCheckChange} value={key} />{categories[key]}</label>                     
                        </li>
                      ))}
                    </ul>
                    <p>※最大2つまで選択できます。</p>
                    {isSubmitted && formState.siteCategory.length === 0 && <p className="regist_error">カテゴリーが未選択です。</p>}
                    {resErrorCat && <p className="regist_error">{resErrorCat}</p>}
                  </dd>
                </dl>
                <dl>
                  <dt>バナー画像</dt>
                  <dd>
                    <input type="file" name="siteImg" onChange={handleFileChange} />
                    <p className="m_t5">※300×80px 推奨、サイズ容量50KB以下</p>
                    {resErrorImg && <p className="regist_error">{resErrorImg}</p>}
                  </dd>
                </dl>
                <dl>
                  <dt>サイト説明文 <span className="red">※</span></dt>
                  <dd>
                    <textarea name="siteDetail" value={formState.siteDetail} onChange={handleInputChange} />
                    <p>※最大100文字まで</p>
                    {isSubmitted && !formState.siteDetail && <p className="regist_error">サイト説明文が未入力です。</p>}
                    {resErrorDetail && <p className="regist_error">{resErrorDetail}</p>}
                  </dd>
                </dl>
              </div>
                    
              
              <p className="registBtn"><input type="submit" value="登録する" /></p>
              
              {/*
              <p className="registBtn"><input type="submit" value="登録テスト" onClick={testSubmmit} /></p>
              */}
            </form>

          )}

          
          
        </div>
      </section>
      <LinkInformationArea />
    </main>
  );
};

export default Siteragist;